import { BaseFilterListRequestModel } from "app/based/baseApiModel/baseFilterListModel/BaseFilterListRequestModel";

export class StoreListRequestEntiy extends BaseFilterListRequestModel {
  partnerCode?: string;
  providerCode?: string;
  isUser?: boolean;
  code?: string;
  page?: number;
  limit?: number;
}
